import { Controller } from "@hotwired/stimulus"

// Closes a <details>-based dropdown when the user clicks outside of it
// or presses Escape. Use with the shared/_actions_dropdown partial:
//   <details data-controller="actions-dropdown" ...>
export default class extends Controller {
  connect() {
    this._onDocClick = this._onDocClick.bind(this)
    this._onKey      = this._onKey.bind(this)
    document.addEventListener("click", this._onDocClick)
    document.addEventListener("keydown", this._onKey)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onKey)
  }

  _onDocClick(event) {
    if (!this.element.open) return
    if (this.element.contains(event.target)) return
    this.element.open = false
  }

  _onKey(event) {
    if (event.key === "Escape" && this.element.open) this.element.open = false
  }
}
